import React from 'react';
import PropTypes from 'prop-types';
import { toGlobalId } from 'graphql-relay';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';

import { SimpleLoadingComponent } from '../../utils/apollo';
import updateHEAccount from '../../mutations/HEAccount/updateHEAccount';
import InstitutionNotificationSettingsPage from './institutionNotificationSettingsPage';

export class InstitutionNotificationSettingsComponent extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    node: PropTypes.object,
    updateHEAccountMutation: PropTypes.func.isRequired,
  };

  onSave = ({ activeMatchNotificationsAdditionalEmails, activeMatchNotificationsContactIds }, onFailure, onSuccess) => {
    const { node: heAccount, updateHEAccountMutation } = this.props;
    updateHEAccountMutation({
      variables: {
        input: {
          heAccount: {
            id: heAccount.id,
            activeMatchNotificationsAdditionalEmails,
            activeMatchNotificationsContactIds,
            heUser: undefined,
          },
        },
      },
    }).then(onSuccess).catch(onFailure);
  };

  render() {
    const { node: heAccount, viewer } = this.props;
    const { heCommunityContacts } = viewer;
    return (
      <InstitutionNotificationSettingsPage
        onSave={this.onSave}
        activeMatchNotificationsAdditionalEmails={heAccount.activeMatchNotificationsAdditionalEmails}
        activeMatchNotificationsContacts={heAccount.activeMatchNotificationsContacts}
        heCommunityContacts={heCommunityContacts}
        heUsers={heAccount.userList}
      />
    );
  }
}

const query = gql`
  query InstitutionSettings($id: ID!) {
      viewer {
        id
        heCommunityContacts {
          mail
          name
          id
        }
      }
      node(id: $id) {
        id
        ... on HEAccount {
          id
          primaryUser {
            id
            firstName
            lastName
            email
            active
            role
            lockStatus
          }
          userList {
            id
            firstName
            lastName
            email
            active
            role
            lockStatus
          }
          activeMatchNotificationsAdditionalEmails
          activeMatchNotificationsContacts {
            id
          }
        }
      }
    }
`;

const graphqlData = graphql(query, {
  options: ({ current }) => ({
    variables: {
      id: toGlobalId('HEAccount', current.viewer.idToken['custom:institution']),
    },
    fetchPolicy: 'cache-and-network',
  }),
});

const mapStateToProps = (state) => ({
  current: state.current,
});

const updateHEAccountMutation = graphql(updateHEAccount, { name: 'updateHEAccountMutation' });
export default compose(
  connect(mapStateToProps),
  SimpleLoadingComponent(graphqlData, updateHEAccountMutation),
)(InstitutionNotificationSettingsComponent);
